import React from 'react';
import styled from 'styled-components';

const BackDrop = styled.div.attrs({})`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
`;

const backdrop = props => {
  return props.show ? (
    <BackDrop className="Backdrop" onClick={props.clicked} />
  ) : null;
};

export default backdrop;
